/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { Options } from '../options.interface';
import { BANKING_PROCESSOR_API_CONFIG } from './banking-processor-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BankingUser } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class BankingTrackWebservice {
  readonly #http = inject(HttpClient);
  readonly #bankingProcessorApiConfig = inject(BANKING_PROCESSOR_API_CONFIG);

  readonly #baseUrl = this.#bankingProcessorApiConfig.baseUrl;

  readonly getStepByTrackIdAndQuestionId = (trackId: string, questionId: string, options?: Options): Observable<any> =>
    this.#http.get<any>(`${this.#baseUrl}/v1/track/${trackId}/step/by-question-id/${questionId}`, options);

  readonly getStepByUserIdAndStepSlug = (userId: string, stepSlug: string, options?: Options): Observable<any> =>
    this.#http.get<any>(`${this.#baseUrl}/v1/user/${userId}/step/by-slug/${stepSlug}`, options);

  readonly getStepByUserIdAndQuestionId = (userId: string, questionId: string, options?: Options): Observable<any> =>
    this.#http.get<any>(`${this.#baseUrl}/v1/user/${userId}/step/by-question-id/${questionId}`, options);

  readonly answerStep = (
    userId: string,
    stepSlug: string,
    responses: Record<string, any>,
    options?: Options
  ): Observable<void> =>
    this.#http.post<void>(`${this.#baseUrl}/v1/user/${userId}/step/by-slug/${stepSlug}`, { responses }, options);

  readonly nextStep = (userId: string, options?: Options): Observable<BankingUser> =>
    this.#http.post<BankingUser>(`${this.#baseUrl}/v1/user/${userId}/step/next`, {}, options);

  readonly previousStep = (userId: string, options?: Options): Observable<BankingUser> =>
    this.#http.post<BankingUser>(`${this.#baseUrl}/v1/user/${userId}/step/previous`, {}, options);

  readonly startTrack = (userId: string, options?: Options): Observable<BankingUser> =>
    this.#http.post<BankingUser>(`${this.#baseUrl}/v1/user/${userId}/start-track`, {}, options);
  
  readonly replayJobs = (userId: string, options?: Options): Observable<void> =>
    this.#http.post<void>(`${this.#baseUrl}/v1/user/${userId}/step/replay-jobs`, {}, options);

  readonly switchTrack = (userId: string, trackId: string, options?: Options): Observable<BankingUser> =>
    this.#http.post<BankingUser>(`${this.#baseUrl}/v1/user/${userId}/switch-track/${trackId}`, {}, options);
}
